import Banner from "../components/banner/Banner";
import Footer from "../components/footer/Footer";
import Navbar from "../components/navbar/Navbar";

import "../components/cart/Cart.css"
import WishlistComp from "../components/wishlist/WishlistComp";
import { useEffect } from "react";

const Wishlist=()=>{
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(
        <div className="bg-imagea">
<Navbar/>
 <Banner title="Wishlist"/>
<WishlistComp/>
<Footer/>
</div>
    )
}
export default Wishlist;